module.exports = __webpack_public_path__ + "static/media/broken_link.b59ec1dd.png";